import React, { useEffect, useMemo } from 'react';
import classnames from 'classnames';
import { connect, useIntl, useLocation } from 'umi';
import { Layout } from 'tea-component';
import LeftMenu from '@/pages/dashboard/components/LeftMenu';
import Loading from '@/pages/dashboard/components/Loadings';
import PermissionNew from '@/pages/dashboard/components/NoPermissionNew';
import { FILTER_CACHE_VALUE_KEY, storage } from '@/utils/utils';
import {
  DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY,
  DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY,
  ORGANIZATION_FUN,
  DEMO_GAME_LIST,
  PAGE_TYPE_PATH,
  demoPaths,
  IS_NOT_REQ_SELECTOR_PAGE,
  IS_NOT_REQ_SELECTOR_PAGE_REALTIMES
} from '../_config/constant';
import './index.scss';
import { parseUrlInfo } from '@/pages/dashboard/utils/utils';
import { findGame } from '@/pages/dashboard/models/dashboard';
import { IS_GLOBAL } from '@/pages/home/_config/config';
import { setMoneyUnit } from '../utils/moneyUnit';
import {
  getCustomFilterKeysFromConfig,
  getCustomFilterList,
  setCustomFilterList,
} from '@/pages/dashboard/components/NewFilter/customFilterList';
import { useEmbeddedPageOptions } from '@home/hooks/useEmbeddedPageOptions';

let intervalId: any;
const { Body, Content } = Layout;
const DashboardLayout = (props: any) => {
  const {
    userInfo,
    rawGameList,
    gameList,
    gameLoading,
    menuLoading,
    currentGame,
    menuList,
    dashboardList,
    userInfoLoading,
    gameConfig,
    selector,
    dispatch
  } = props;

  const location = useLocation();
  const embedOptions = useEmbeddedPageOptions();
  const { pathname } = location;
  const { formatMessage } = useIntl();
  const { userId, code } = storage.getItem(DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY) || {};
  const { urlId: urlGameCode = '', realPath } = parseUrlInfo(pathname);
  const { rawDataFrame: dataFrame } = currentGame || {};

  useEffect(() => {
    // 如果筛选器方案中的用户和当前用户不一致，则删除缓存
    const filterSaveVal = storage.getItem(DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY) || {};
    const { userId: filterSaveUseId, gameCode: filterSaveGame } = filterSaveVal;
    const filterSaveMesIsCurrent =
      filterSaveUseId === userId && filterSaveGame === code;

    !filterSaveMesIsCurrent &&
      storage.removeItem(DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY);
  }, [userId, code]);

  useEffect(() => {
    if (gameList.length < 1) {
      // 获取游戏列表
      props.dispatch({
        type: 'dashboard/getGameList',
      });
    }
  }, []);

  useEffect(() => {
    if (!userInfo || rawGameList.length < 1) {
      return;
    }
    let gameList = [...rawGameList];
    const { userid: curUserId, organization = [] } = userInfo || {};
    // todo Global环境处理逻辑，屏蔽无权限的游戏, Funcom 屏蔽demo
    if (IS_GLOBAL) {
      // Funcom屏蔽demo
      // Funcom通过demo url 进入则不屏蔽
      if (organization.includes(ORGANIZATION_FUN) && !demoPaths.some(path => pathname.includes(path))) {
        gameList = (gameList || []).filter(item => !DEMO_GAME_LIST.includes(item.game_code));
      }
    }
    // 获取gamecode
    // const { urlId } = parseUrlInfo(history.location.pathname);
    // const { code, userId } = storage.getItem(DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY) || {};
    // const gameCode = urlId || code || '';
    // 优先使用url中的gamecode，没有的话使用缓存
    // global环境用户登录系统，默认进入pc console的demo
    const gameCode = urlGameCode || (userId === curUserId && code) || (IS_GLOBAL ? 'pc_demo' : '');
    const currentGame = findGame(gameCode, gameList);
    if (currentGame?.is_access) {
      storage.setItem(DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY, {
        userId: curUserId,
        code: currentGame?.game_code,
      });
    }
    dispatch({
      type: 'dashboard/save',
      payload: {
        gameList,
        currentGame
      },
    });
  }, [rawGameList, userInfo]);

  const isHaveSystemDashboard = useMemo(() => {
    const dashboardArr = dashboardList?.filter((item: { page_type: string; path: any; }) => ((item?.page_type === PAGE_TYPE_PATH) && item?.path));
    return dashboardArr?.length > 0;
  }, [dashboardList]);
  // const isNotReqSelectorArr = ['monetization/revenue/platformSalesBreakdown', 'monetization/salesOverview', 'monetization/salesOverview/revenue', 'monetization/salesOverview/breakdown', 'monetization/salesBreakdown']
  // 初始进入页面如果是Platform Sales Breakdown页面，则不在这里请求selector
  // const isNightingale = NIGHTINGALE_GAME?.includes(urlGameCode);
  // 应jason哥需求，不属于pc、pc、console以及夜莺的游戏不请求selector接口，同时不包含框架内报表也不需要请求selector接口
  // lipass游戏框架由none调整为lipass
  // 非游戏框架或者没有框架报表，不用请求相关数据
  const isNotReq = !dataFrame || dataFrame === 'none' || dataFrame === 'lipass' || !isHaveSystemDashboard;
  const isNotReqSelector = dataFrame === 'casual' ? [...IS_NOT_REQ_SELECTOR_PAGE, ...IS_NOT_REQ_SELECTOR_PAGE_REALTIMES].includes(realPath) : IS_NOT_REQ_SELECTOR_PAGE?.includes(realPath);

  useEffect(() => {
    props.dispatch({
      type: 'dashboardSetting/setFilterSaveDuration',
      payload: {
        data: '',
      },
    });

    props?.dispatch({
      type: 'rangePikerLeft/setRangePickerLeftData',
      payload: {
        data: []
      },
    });
  }, [currentGame?.game_code, pathname]);

  useEffect(() => {
    const { game_code: gameCode } = currentGame || {};
    setMoneyUnit(gameCode);
    // 无currentGame 或者currentGame跟url中的不匹配，直接return
    // window.sessionStorage.removeItem(FILTER_CACHE_VALUE_KEY);
    // 请求游戏配置：页面筛选器配置
    if (!currentGame || !gameCode || gameCode !== urlGameCode || isNotReq) return;

    props.dispatch({
      type: 'dashboard/getExplainInfo',
      payload: {
        gameCode: currentGame?.game_code,
      },
    });

    // 请求游戏筛选器方案下拉框
    props.dispatch({
      type: 'dashboardSetting/getSelectorSchemeList',
      payload: {
        gameCode,
      },
    });
    // 请求指标信息
    props.dispatch({
      type: 'dashboard/getMetricsInfo',
      payload: {
        gameCode,
      },
    });
    // 请求 Agent 入口配置
    props.dispatch({
      type: 'dashboard/getAgentInfoConfig',
      payload: {
        gameCode,
      },
    });

    // 获取跑马灯
    props.dispatch({
      type: 'dashboard/getMarqueeInfos',
      payload: {
        gameCode,
      },
    });
    // 每隔5分钟 获取顶部的跑马灯通知信息
    clearInterval(intervalId);
    intervalId = setInterval(() => {
      // 如果当前页签处于非活跃状态，不执行后续操作
      if (document.hidden || document.visibilityState === 'hidden') {
        return;
      }
      
      props.dispatch({
        type: 'dashboard/getMarqueeInfos',
        payload: {
          gameCode,
        },
      });
    }, 300000);
    return () => clearInterval(intervalId);
  }, [currentGame, urlGameCode, isNotReq, isNotReqSelector]);

  useEffect(() => {
    // 切换游戏时，清除缓存
    window.sessionStorage.removeItem(FILTER_CACHE_VALUE_KEY);
  }, [currentGame]);

  useEffect(() => {
    const { game_code: gameCode } = currentGame || {};
    if (!currentGame || !gameCode || gameCode !== urlGameCode || isNotReq || isNotReqSelector) return;
    // 获取游戏列表
    // 请求游戏筛选器下拉框
    props.dispatch({
      type: 'dashboardSetting/getSelector',
      payload: {
        gameCode,
        dataFrame
      },
    });
  }, [currentGame, urlGameCode, isNotReq,  isNotReqSelector]);

  // 无框架报表的时候，不请求config接口会导致订阅不展示，所以还是要请求的
  useEffect(() => {
    const { game_code: gameCode } = currentGame || {};
    // 请求游戏配置：页面筛选器配置
    if (!currentGame || !gameCode || gameCode !== urlGameCode) return;
    props.dispatch({
      type: 'dashboardSetting/getGameConfig',
      payload: {
        gameCode,
      },
    });
  }, [currentGame, urlGameCode]);

  // 合并 config 中 is_custom===1 的筛选器 key 到自定义筛选器列表（在 gameConfig 和 selector 都就绪后）
  useEffect(() => {
    if (!gameConfig || !selector) return;
    if (gameConfig?.game_code !== selector?.gameCode) return;
    const configKeys = getCustomFilterKeysFromConfig(gameConfig);
    if (configKeys.length === 0) return;
    const merged = [...new Set([...getCustomFilterList(), ...configKeys])];
    setCustomFilterList(merged, true);
  }, [gameConfig, selector]);

  // 全局loading
  const loading = useMemo(() => {
    if (gameLoading !== false || userInfoLoading !== false) {
      return <Loading />;
    }
    return null;
  }, [gameLoading, userInfoLoading]);
  // 异常处理,内容中的loading和无权限
  const contentErrorInfo = useMemo(() => {
    // gameloading 的时候直接return
    if (loading) {
      return null;
    }

    // gameList请求完，检测是否有游戏列表，是否查询到游戏，以及是否有游戏权限
    if (gameList.length < 1 || !currentGame || !currentGame.is_access) {
      return <PermissionNew gameCode={currentGame?.game_code} showButton={!IS_GLOBAL} />;
    }

    // 左侧菜单加载，以及currentGame和url中的gamecode不匹配的情况,非游戏框架不用判定gameconfig
    if (!menuList || menuLoading || currentGame.game_code !== urlGameCode || (!isNotReq && gameConfig?.game_code !== urlGameCode)) {
      return <Loading />;
    }

    // 没有报表，提示当前业务还没有配置任何报表
    if (menuList && dashboardList.length < 1) {
      return <PermissionNew gameCode={currentGame?.game_code} showButton={false} message={formatMessage({ id: 'menu_no_any_dashboard_exist' })} />;
    }
    return null;
  }, [loading, gameList, currentGame, menuList, dashboardList, menuLoading, gameConfig, isNotReq, urlGameCode]);

  return (
    <>
      {/* <Header className="layout-header"> */}
      {/*  <NavHader />*/}
      {/* </Header> */}
      <Body
        className={classnames('layout-body dtb-db-layout', {
          'dbh-embed-hide-page-header': embedOptions.hidePageHeader,
          'dbh-embed-hide-page-tabs': embedOptions.hidePageTabs,
        })}
      >
        {loading ? (
          loading
        ) : (
          <>
            {!embedOptions.hideLeftMenu && <LeftMenu />}
            {/* <Navigation /> */}
            {/* loading 未结束不允许进入页面（提前进入页面会存在重复请求问题） */}
            <Content>{contentErrorInfo || props.children}</Content>
          </>
        )}
      </Body>
    </>
  );
};

export default connect((state: any) => {
  const { loading, dashboard, dashboardSetting, home } = state;
  return {
    userInfo: home.userInfo,
    currentGame: dashboard.currentGame,
    rawGameList: dashboard.rawGameList,
    gameConfig: dashboardSetting?.gameConfig,
    selector: dashboardSetting?.selector,
    gameList: dashboard.gameList,
    menuList: dashboard.menuList,
    dashboardList: dashboard.dashboardList,
    gameLoading: loading.effects['dashboard/getGameList'],
    userInfoLoading: loading.effects['home/getUserInfo'],
    menuLoading: loading.effects['dashboard/getLeftMenuList'],
  };
})(DashboardLayout);
